/* VSUAL — Header
   Dos responsabilidades:
   1. alternar el estado sólido cuando el scroll pasa el umbral de la sección
   2. abrir y cerrar el drawer móvil, con foco atrapado y Escape

   Se re-ejecuta en el editor de temas, donde las secciones se recargan sin
   recargar la página. Por eso todo el bind es idempotente. */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function initHeader(header) {
    if (header.dataset.vsualBound === 'true') return;
    header.dataset.vsualBound = 'true';

    var threshold = parseInt(header.dataset.stuckAfter, 10);
    if (isNaN(threshold)) threshold = 80;

    var ticking = false;
    function apply() {
      header.classList.toggle('is-stuck', window.scrollY > threshold);
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    apply();

    // ---- drawer ----
    var drawer = header.querySelector('[data-vsual-drawer]');
    var openBtn = header.querySelector('[data-vsual-open]');
    var closeBtn = header.querySelector('[data-vsual-close]');
    if (!drawer || !openBtn) return;

    var lastFocused = null;

    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';

      if (open) {
        lastFocused = document.activeElement;
        var first = drawer.querySelector(FOCUSABLE);
        if (first) first.focus();
      } else if (lastFocused && lastFocused.focus) {
        lastFocused.focus();
      }
    }

    openBtn.addEventListener('click', function () { setOpen(true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setOpen(false);
        return;
      }
      if (e.key !== 'Tab') return;

      var items = Array.prototype.filter.call(
        drawer.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // cerrar al navegar dentro del drawer
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) setOpen(false);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-vsual-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // ---- contador de la bolsa ----
  // El badge se esconde con data-count="0", asi que hay que mover el atributo
  // y no solo el texto: si no, se agrega algo y el badge sigue oculto.
  function paintCount(n) {
    document.querySelectorAll('.vs-hdr__cart-count').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-count', n);
    });
  }

  function syncCount() {
    if (!window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); })
      .catch(function () {});
  }

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, syncCount);
  });

  // el editor de temas recarga secciones sueltas
  document.addEventListener('shopify:section:load', initAll);
})();
